import { createAsyncThunk } from "@reduxjs/toolkit";

import publisherAPIs from "../../services/api/publisher";

export const getYouTubePlaylists = createAsyncThunk("common/youTubePlayLists", async (payload) => {
  try {
    const response = await publisherAPIs.getYouTubePlaylists(payload);
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});
